import { render } from "./ui-loader.vue?vue&type=template&id=5bef7741&scoped=true"
import script from "./ui-loader.vue?vue&type=script&lang=js"
export * from "./ui-loader.vue?vue&type=script&lang=js"

import "./ui-loader.vue?vue&type=style&index=0&id=5bef7741&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bef7741"],['__file',"src/components/ui/ui-loader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5bef7741"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5bef7741', __exports__)) {
    api.reload('5bef7741', __exports__)
  }
  
  module.hot.accept("./ui-loader.vue?vue&type=template&id=5bef7741&scoped=true", () => {
    api.rerender('5bef7741', render)
  })

}


export default __exports__